import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';

const VideoViewer = ({ contentUrl, fileName }) => (
  <Box style={{
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px 0',
  }}>
    <video
      controls
      controlsList="nodownload"
      playsInline
      src={contentUrl}
      title={fileName}
      style={{
        maxWidth: '100%',
        maxHeight: '70vh',
        borderRadius: 4,
        background: '#000',
      }}
    >
      Tu navegador no soporta la reproducción de video.
    </video>
  </Box>
);

VideoViewer.defaultProps = {
  contentUrl: '',
  fileName: '',
};

VideoViewer.propTypes = {
  contentUrl: PropTypes.string,
  fileName: PropTypes.string,
};

export default VideoViewer;
